import { useDispatch } from 'react-redux';

export default (callback: Function): any => {
  const dispatch = useDispatch();

  return (...args: [any]): any => callback(dispatch, ...args);
};
